module.exports = __webpack_public_path__ + "static/media/hoisted-greeting-one.be4ea2f0.png";